import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PAGE_SIZE } from "./constants";
import {
  activateLicenseAsync,
  initialAsync,
  updateAsync,
  transferLicenseAsync,
} from "./operations";
import { SoftwareState } from "./state";
import { LoadState } from "./types";

const initialState: SoftwareState = {
  apps: {
    loading: "Loading",
    maxPage: 1,
    pageIndex: 0,
    pageSize: PAGE_SIZE, // const化
    searchText: "",
  },
  domains: {
    entitlements: {
      Entitlements: [],
    },
  },
};

export const softwareSlice = createSlice({
  name: "software",
  initialState,
  reducers: {
    // 現在表示しているページのindexを更新する。
    changeNowIndex: (state, action: PayloadAction<{ pegeNumber: number }>) => {
      const { pegeNumber } = action.payload;
      state.apps.pageIndex = pegeNumber;
    },
    // 現在の検索文字列を更新する。
    changeSearchText: (state, action: PayloadAction<{ text: string }>) => {
      const { text } = action.payload;
      state.apps.searchText = text;
    },
    // 現在の検索文字列を更新する。
    changeLoadState: (
      state,
      action: PayloadAction<{ loadstate: LoadState }>
    ) => {
      const { loadstate } = action.payload;
      state.apps.loading = loadstate;
    },
    changePopupTarget: (state, action: PayloadAction<{ eId: string }>) => {
      const { eId } = action.payload;
      const target = state.domains.entitlements?.Entitlements.filter(
        (x) => x.id === eId
      ).shift();
      if (target) {
        state.apps.popupTarget = {
          eId: target.id,
          name: target.productName,
          pkId: target.pkId,
          version: target.version,
        };
      }
    },
    clearPopupTarget: (state) => {
      state.apps.popupTarget = undefined;
    },
    changeTransferTarget: (state, action: PayloadAction<{ eId: string }>) => {
      const { eId } = action.payload;
      const target = state.domains.entitlements?.Entitlements.filter(
        (x) => x.id === eId
      ).shift();
      if (target) {
        state.apps.transferTarget = {
          eId: target.id,
          name: target.productName,
          pkId: target.pkId,
          version: target.version,
        };
      }
    },
    clearTransferTarget: (state) => {
      state.apps.transferTarget = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(initialAsync.pending, (state) => {
      state.apps = initialState.apps;
      state.domains = initialState.domains;
    });
    builder.addCase(initialAsync.fulfilled, (state, action) => {
      const { payload } = action;
      state.apps = payload.apps;
      state.domains = payload.domains;
    });
    builder.addCase(initialAsync.rejected, (state) => {
      // TODO:errorを更新する
      state.apps.loading = "LoadError";
    });
    builder.addCase(updateAsync.pending, (state) => {
      state.apps.loading = "Loading";
    });
    builder.addCase(updateAsync.fulfilled, (state, action) => {
      const { payload } = action;

      state.apps.loading = "Loaded";
      state.apps.maxPage = payload.maxPage;
      state.apps.pageIndex = payload.pageIndex;

      if (state.domains.entitlements) {
        state.domains.entitlements.Entitlements = payload.entitlements;
      } else {
        state.domains.entitlements = {
          Entitlements: payload.entitlements,
        };
      }
    });
    builder.addCase(updateAsync.rejected, (state) => {
      // TODO:errorを更新する
      state.apps.loading = "LoadError";
    });
    builder.addCase(activateLicenseAsync.pending, (state) => {
      state.apps.excuteState = "Excuting";
    });
    builder.addCase(activateLicenseAsync.fulfilled, (state) => {
      state.apps.excuteState = "Excuted";
      state.apps.popupTarget = undefined;
    });
    builder.addCase(activateLicenseAsync.rejected, (state) => {
      state.apps.excuteState = "ExcuteError";
    });
    builder.addCase(transferLicenseAsync.pending, (state) => {
      state.apps.excuteState = "Excuting";
    });
    builder.addCase(transferLicenseAsync.fulfilled, (state) => {
      state.apps.excuteState = "Excuted";
      state.apps.transferTarget = undefined;
    });
    builder.addCase(transferLicenseAsync.rejected, (state) => {
      state.apps.excuteState = "ExcuteError";
    });
  },
});
export const {
  changeNowIndex,
  changeSearchText,
  changeLoadState,
  changePopupTarget,
  clearPopupTarget,
  changeTransferTarget,
  clearTransferTarget,
} = softwareSlice.actions;
export default softwareSlice.reducer;
